import axios from 'axios'
import { Acknowledgements } from 'src/enums'
import { getResponseData } from 'src/queries/network.utils'
import {
  OrganizationAcknowledgementsResponse,
  PostAcknowledgementRequest,
} from 'src/queries/organizations/acknowledgements/acknowledgements.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

// Both endpoints use the authed JSON API request config.

export const getOrganizationAcknowledgements = async (
  type: Acknowledgements,
): Promise<OrganizationAcknowledgementsResponse> => {
  return getResponseData(
    axios.get<OrganizationAcknowledgementsResponse>(
      `/acknowledgements?type=${type}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}

export const postOrganizationAcknowledgement = async (
  request: PostAcknowledgementRequest,
): Promise<void> => {
  return getResponseData(
    axios.post<void>(
      `/acknowledgements`,
      request,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
